// Hero.js - Enhanced with more keywords
import { motion } from 'framer-motion';
import { FiDownload, FiMail, FiGrid, FiBriefcase } from 'react-icons/fi';
import SocialIcons from './SocialIcons';
import './Hero.css';

const ROLES = ['Full-Stack Developer', 'Founder @ Ranjan Solution', 'CS Engineering Student'];
const CV_URL = 'https://drive.google.com/file/d/1i9F7hrNMIX_Xrm_VGw1d-cTyU7ZqBFd3/view?usp=sharing';

function Hero() {
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="hero">
      <div className="hero__bg">
        <div className="hero__gradient hero__gradient--1" />
        <div className="hero__gradient hero__gradient--2" />
        <div className="hero__gradient hero__gradient--3" />
        <div className="hero__grid" />
      </div>
      
      <div className="hero__content section">
        <motion.p
          className="hero__label"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          👋 Hello, I'm
        </motion.p>
        
        <motion.h1
          className="hero__title"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.08 }}
        >
          <span className="hero__title-name">Shyam Ranjan</span>
        </motion.h1>
        
        <motion.p
          className="hero__desc"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <strong>Founder & Full-Stack Developer</strong> at Ranjan Solution with 1+ year of experience in 
          building enterprise web applications. Successfully deployed <strong>20+ production systems</strong> serving 
          50K+ users. Specialized in <strong>PHP, MySQL, JavaScript</strong> and educational technology solutions.
        </motion.p>
        
        <motion.div
          className="hero__pills"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          {ROLES.map((role, i) => (
            <motion.span
              key={role}
              className="hero__pill"
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.35 + i * 0.06 }}
            >
              {role}
            </motion.span>
          ))}
        </motion.div>
        
        <motion.div
          className="hero__actions"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.45 }}
        >
          <motion.a
            href={CV_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="hero__btn hero__btn--primary gradient-btn"
            whileHover={{ scale: 1.03, boxShadow: '0 0 36px var(--accent-glow)' }}
            whileTap={{ scale: 0.98 }}
          >
            <FiDownload className="hero__btn-icon" aria-hidden />
            Download CV
          </motion.a>
          
          <motion.button
            type="button"
            className="hero__btn hero__btn--secondary"
            onClick={() => scrollTo('contact')}
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.98 }}
          >
            <FiMail className="hero__btn-icon" aria-hidden />
            Hire Me
          </motion.button>
          
          <motion.button
            type="button"
            className="hero__btn hero__btn--ghost"
            onClick={() => scrollTo('projects')}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <FiBriefcase className="hero__btn-icon" aria-hidden />
            View Projects
          </motion.button>
        </motion.div>
        
        <motion.div
          className="hero__social"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.55 }}
        >
          <SocialIcons size="medium" />
        </motion.div>
        
        <motion.div
          className="hero__scroll"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1 }}
        >
          <span className="hero__scroll-text">Scroll to explore</span>
          <motion.span
            className="hero__scroll-line"
            animate={{ scaleY: [0.2, 1, 0.2] }}
            transition={{ duration: 1.5, repeat: Infinity, ease: 'easeInOut' }}
          />
        </motion.div>
      </div>
    </section>
  );
}

export default Hero;